import React, { useContext, useState } from "react";
import { useHistory } from "react-router";
import { PermissionContext, RolePermissions } from "appContext";
import { ReactComponent as SchoolIcon } from "assets/img/svg/school.svg";
import { getScreenCards } from "views/pages/manage/finOps/IssueStock/search/SearchCard";
import { pages } from "../../common/constant";

const ModuleCards = ({ setListVisible }) => {
  const history = useHistory();

  const SchoolMasterPermission = RolePermissions(
    useContext(PermissionContext),
    pages["schoolMaster"]["id"]
  );

  const BulkSchoolUploadPermission = RolePermissions(
    useContext(PermissionContext),
    pages["bulkSchoolUpload"]["id"]
  );

  const cards = [
    ...(SchoolMasterPermission?.length
      ? [
          {
            heading: "School Master",
            subHeading: "Create or edit schools",
            icon: <SchoolIcon />,
            action: () => {
              history.push("/admin/schoolMaster/getAll");
            },
          },
        ]
      : []),

    ...(BulkSchoolUploadPermission.length
      ? [
          {
            heading: "Bulk School Uploads",
            subHeading: "Upload schools in bulk",
            icon: <SchoolIcon />,
            action: () => {
              history.push("/admin/schoolMaster/bulkSchoolUpload");
            },
          },
        ]
      : []),
  ];

  return (
    <>
      <div className={`screen-cards-container`}>{getScreenCards(cards)}</div>
    </>
  );
};

export default ModuleCards;
